import { Button, Input } from "antd";
import {
    CheckCircleFilled
} from "@ant-design/icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function ConnectCodeView() {
    const { t } = useTranslation();
    const [selectedIds, setSelectedIds] = useState<string[]>([]);

    const toggleSelect = (id: string) => {
        setSelectedIds((prev) =>
            prev.includes(id)
                ? prev.filter((item) => item !== id)
                : [...prev, id]
        );
    };

    return (
        <div className="flex-1 flex flex-col items-center text-center">

            <div className="w-28 h-28 bg-gray-100 rounded-full mb-6">
                <img src="https://pancake.vn/static/cc-assets/images/no-page-found.svg" style={{ height: '145px' }} alt="Connect Code" />
            </div>

            <h3 className="text-lg font-medium mb-3">
                {t('chats.no_page')}
            </h3>
            <div className="text-sm text-gray-500 max-w-[400px]">
                {t('chats.no_page_desc')}
            </div>
        </div>
    );
}